import { render, staticRenderFns } from "./extend-info.vue?vue&type=template&id=2dbfee24&scoped=true&"
import script from "./extend-info.vue?vue&type=script&lang=js&"
export * from "./extend-info.vue?vue&type=script&lang=js&"
import style0 from "./extend-info.vue?vue&type=style&index=0&id=2dbfee24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbfee24",
  null
  
)

export default component.exports